import {AuthModel} from '../auth/core/_models'
import {isOnPremisesInstallation} from '../auth/core/onPremisesAccess'

/**
 * «QR سامانه مؤدیان روی چاپ» in «امکانات تازه» (user request 2026-10-26, after panel 60.11.590/591 and backend
 * 1.0.0.741): like the other announcements, the header's icon shakes until the list is opened, and the item opens
 * this introduction (TaxPublicQrIntroGate).
 */
export const TAX_PUBLIC_QR_INTRO_EVENT = 'mp:tax-public-qr-intro'

/** The announcement's id in the user's seen list (whatsNewSeen); a new announcement takes a new id. */
export const TAX_PUBLIC_QR_ANNOUNCEMENT = 'tax-public-qr-1405-08'

export const openTaxPublicQrIntro = (): void => {
  window.dispatchEvent(new Event(TAX_PUBLIC_QR_INTRO_EVENT))
}

/** Whoever works in a business on the central panel; an On-Premises install never asks the organisation for it. */
export const shouldAnnounceTaxPublicQr = (user?: AuthModel | null) =>
  Boolean(user && !user.support && Number(user.cpi || 0) > 0 && !isOnPremisesInstallation(user))

export const INVOICES_LIST_PATH = '/apps/invoice-management/invoices'
